export const rachelZoePageData = {
  seo: {
    title: 'Joy | Top to Bottom, Head to Toe Your Wedding by Rachel Zoe',
    content: 'A unique red carpet experience just for you by Rachel Zoe',
  },
  rules: {
    seoText: 'Rachel Zoe Sweepstakes',
  },
  sections: {
    hero: {
      title: 'Plan Your Wedding in Style',
      content: 'Explore registry curations and choose your digital wedding theme — all by Rachel Zoe.',
      enterToWinBtn: 'Enter To Win',
      watchTheVideoBtn: 'Watch Video',
      videoUrl: 'https://player.vimeo.com/video/787782992?h=23a3b57e35&badge=0&player_id=0&texttrack=en-x-autogen&app_id=58479/embed',
      backgroundVideoUrl: 'https://player.vimeo.com/video/787961882?h=d3a3f1cdda&badge=0&player_id=0&app_id=58479/embed',
    },
    headToToe: {
      title: 'Get Styled Head-to-Toe, Plus Fabulous Extras.',
      groups: [
        {
          icon: 'curations',
          title: 'Rachel’s Registry Picks',
          body: 'Add the fashion icon’s fabulous faves to your wedding registry.',
        },
        {
          icon: 'inviteRZ',
          title: 'Invites + Save the Dates',
          body: 'Choose from Rachel Zoe’s exclusive collection of digital prints.',
        },
        {
          icon: 'ww',
          title: 'Wedding Website',
          body: 'Create a matching wedding website designed by Rachel Zoe.',
        },
      ],
    },
    quote: {
      title: '“Everybody deserves a red carpet moment for their wedding, so I am here to give you yours.”',
      eyebrow: 'Rachel Zoe',
    },
    curatedRegistry: {
      heading: {
        eyebrow: 'For Every Couple',
        title: 'By Rachel, Only on Joy.',
      },
      subHeading: {
        eyebrow: 'Curated Registry',
        title: 'Rachel’s Favorites',
        body: 'From the fashionable to the functional, discover Rachel’s must-have items to help you build your registry in style.',
      },
      hosting: {
        title: 'Host a Stylish Dinner Party',
      },
      kitchen: {
        title: 'Style & Organize a Bar Cart',
      },
      livingRoom: {
        title: 'Decorate Your Dream Living Room',
      },
      watchVideo: 'Watch the Video',
      ctaText: 'View All Curations',
      seeThisCurationText: 'See this curation',
      curationVideoUrls: [
        {
          video: 'https://player.vimeo.com/video/787933278?h=1734f31f18&badge=0&player_id=0&texttrack=en-x-autogen&app_id=58479/embed',
          backgroundVideo: 'https://player.vimeo.com/video/787962749?h=5e32a6826c&badge=0&player_id=0&app_id=58479/embed',
        },
        {
          video: 'https://player.vimeo.com/video/787789742?h=3ea00a1514&badge=0&player_id=0&texttrack=en-x-autogen&app_id=58479/embed',
          backgroundVideo: 'https://player.vimeo.com/video/787962774?h=dc4a7884f5&badge=0&player_id=0&app_id=58479/embed',
        },
        {
          video: 'https://player.vimeo.com/video/787791327?h=3c92e5609d&badge=0&player_id=0&texttrack=en-x-autogen&app_id=58479/embed',
          backgroundVideo: 'https://player.vimeo.com/video/787962705?h=9d50b319b6&badge=0&player_id=0&app_id=58479/embed',
        },
      ],
    },
    weddingSuite: {
      eyebrow: 'Wedding Suite',
      title: 'From Website to Invites',
      body:
        'Get the full Rachel Zoe wedding experience with her collection of digital Save the Dates, invitations and website themes. Exclusively on Joy.',
      cta: 'View All Designs',
    },
  },
} as const;
